import Logger from '@yakit/core/logger'; let log = Logger(false);
import { makeQueryStore } from '@yakit/core/resource'
import { extend } from "@yakit/core/objectz"
import { f7 } from 'framework7-svelte'
import { ArTran } from '~/types/entities/ArTran';
//----end imports---

/**
 * Customer Rest Api additions
 */
export function createTranAdjustQuery(){
  const resource = makeQueryStore({ key: 'ar.tran' })

  async function getTran() {
    try {
      const router = f7?.views?.main?.router
      if(router) {
        const route = router.currentRoute
        if(route?.params?.id) {
          log("artran init tranId from route", route.params.id)
          return await resource.loadActive(Number(route.params.id))
        }
      }
    } catch(err) {
      log("artran init error getting tranId from route", err)
    }
    return null
  }

  /**
   * Override
   */
  async function init() {
    let custId
    //if(resource.isReady()) return
    await resource.loadConfigs()
    // await resource.loadMeta()
    //setup default sort
    resource.sort.set({dueDate:'asc'})
    
    //TODO: should be done in model
    const tran = await getTran() as ArTran | null
    if(tran && tran.customer?.id) {
      custId = tran.customer.id
      log("artran init tran from route, custId", custId)
    }
    
    //restrict by custId
    log("artran restrictSearch init custId", custId)
    if(!custId) throw "customer id is not set yet, make sure its set before initializing"
    resource.restrictSearch.set({customerId: custId, state: 0, docType: ['IN']})
    resource.setReady()
    return tran
  }

  extend(resource, { init })

  return resource
}




